import { useBackend } from "../../services";

export const useConfirmDiscogsImport = () => {
  const { patch } = useBackend();
  return async () => {
    return await patch("discogs/import");
  };
};
